import { notDesktop, styled, Text, useTranslation } from '@obvio/app'
import {
  CheckboxInput,
  Form,
  FormPage,
  Stack,
  Submit,
  TextArea,
  TextInput,
} from '@obvio/ui'

import { FadeIn } from '../FadeIn'

import type { ReactElement } from 'react'

const MaxWidthStack = styled(Stack)`
  width: 80%;
  @media ${notDesktop} {
    width: 100%;
  }
  margin: 0 auto;
`

const InterestAreas = styled(Stack)`
  text-align: left;
`

const StackWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
`

const TextAreaSeparate = styled.div`
  margin-top: ${(theme) => theme.spacing.extraLarge} !important;
`

export function FormFutureEvent(): ReactElement {
  const { t } = useTranslation()
  return (
    <Form contextOnly>
      <FormPage>
        <MaxWidthStack kind="vertical" spacing="medium">
          <TextInput name="name" label="Full name" />
          <TextInput name="companyName" label="Company name" />
          <TextInput name="email" label="E-mail" />
          <TextInput name="phone" label="Phone number" />
          <TextInput name="site" label="Site" />
          <TextAreaSeparate>
            <TextArea
              name="message"
              label="Your message"
              rows={10}
              placeholder="Enquiry message (250 character limit)"
            />
          </TextAreaSeparate>
          <InterestAreas kind="vertical">
            <Text tag="span">INTEREST AREAS</Text>
            <StackWrap>
              <CheckboxInput name="graphics" label="Graphics" />
              <CheckboxInput name="music" label="Music" />
              <CheckboxInput name="eventManagement" label="Event management" />
              <CheckboxInput name="installation" label="Installation" />
              <CheckboxInput name="catering" label="Catering" />
              <CheckboxInput name="event" label="Event service" />
              <CheckboxInput name="space" label="Exhibition space" />
            </StackWrap>
          </InterestAreas>
          <Submit>SEND APPLICATION</Submit>
        </MaxWidthStack>
      </FormPage>
      <FormPage successPage>
        <FadeIn>
          <Text tag="h2" as="h4">
            {t('joinForm.sent')}
          </Text>
        </FadeIn>
      </FormPage>
    </Form>
  )
}
